// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // codClient: '271',
  // clientId: '6admb7nmmpu1vboag91h686kbq',
  // clientSecret: '1rbkcd81k1flu516sq61bv12bav86280d5b3grgdh7tb8a6i1mfl',

  // codClient: '479',
  // clientId: '2s6iob9p3isdmiureshus3e015',
  // clientSecret: '16n76fo9q16qtl3ntm2v40v45t2va8erqnr10ma90dl4368lg28c',

  // apiClientes: {
  //   url: 'https://api.mia-assistance.com/maip_api_clients_be-web',
  //   url_auth: 'https://auth.mia-assistance.com/oauth2/token',
  //   url_Assistance: 'https://api.mia-assistance.com/maip_api_assistances_be-web'
  // },

  codClient: '479',
  clientId: '2s6iob9p3isdmiureshus3e015',
  clientSecret: '16n76fo9q16qtl3ntm2v40v45t2va8erqnr10ma90dl4368lg28c',

  apiClientes: {
    url: 'https://api.mia-assistance.com/maip_api_clients_be-web',
    url_auth: 'https://auth.mia-assistance.com/oauth2/token',
    url_Assistance: 'https://api.mia-assistance.com/maip_api_assistances_be-web'
  },

  accsmart: {
    "url": "https://api.mapfre.com/srv/accsmart",
    "userTk": "MAICLIENT",
    "pwdTK": "M$1client"
  },

  encuestas: {
    url: "https://dev.smartreportmovil.com/SmartReportOpsAndi/api/SurveyLink/GetLink"
  },
  
  // regional: "assets/json/nissan/subsidiarias.json",
  // i18n: "assets/i18n/",
  // content: "nissan/"

  // regional: "https://dnk6guso1zekt.cloudfront.net/content/chile/nissan/assets/json/subsidiarias.json",
  // i18n: "https://dnk6guso1zekt.cloudfront.net/content/chile/nissan/assets/i18n/",
  // content: "https://dnk6guso1zekt.cloudfront.net/content/chile/nissan/",

  regional: "https://d27lz5g7n8oceq.cloudfront.net/content/chile/nissan/assets/json/subsidiarias.json",
  i18n: "https://d27lz5g7n8oceq.cloudfront.net/content/chile/nissan/assets/i18n/",
  content: "https://d27lz5g7n8oceq.cloudfront.net/content/chile/nissan/",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
